import {Switch, Route, Redirect} from 'react-router-dom';

import {CustomRouteProps} from 'types/ui';

import ForgotPassword from 'pages/ForgotPassword';
import Login from 'pages/Login';
import ResetPassword from 'pages/ResetPassword';
import {NewSignup} from 'pages/Signup';
import {Toaster} from 'react-hot-toast';

const authRoutes: CustomRouteProps[] = [
  {path: '/login', component: Login},
  // {path: '/signup', component: Signup},
  {path: '/signup', component: NewSignup},
  {path: '/forgot_password', component: ForgotPassword},
  {path: '/reset_password', component: ResetPassword},
];

function AuthApp() {
  return (
    <div className="--full-width --center">
      <Switch>
        {authRoutes.map((route) => (
          <Route key={route.path} {...route} />
        ))}
        <Redirect to="/login" />
      </Switch>
      <Toaster />
    </div>
  );
}

export default AuthApp;
